import styled, { css } from "styled-components";
import { Icon } from "@evergis/ui";

export const cropMixin = css`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
`;

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { palette } }) => palette.elementDark};
  color: ${({ theme: { palette } }) => palette.textPrimary};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.small};
  padding: 1.5rem;
  width: 100%;

  ${Icon}::after {
    font-size: 1.5rem;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const Label = styled.span`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary};
  width: 100%;
  text-align: center;

  ${cropMixin};
`;

export const Value = styled.span`
  font: ${({ theme: { fonts } }) => fonts.standard};
  color: ${({ theme: { palette } }) => palette.textPrimary};
  width: 100%;
  text-align: center;

  ${cropMixin};
`;
